import { observer } from 'mobx-react-lite';

const DownloadPdfTab = ({ download_section_text, main_text, pdf_file = {} }) => {
    return (
        <div className="flex flex-col md:flex-row">
            <div className="wysiwyg pb-8 max-md:px-5 md:w-2/3 md:pr-8" dangerouslySetInnerHTML={{ __html: main_text }} />
            <div className="flex h-[1px] w-full md:hidden" />
            <div className="md:w-1/3 md:pl-14">
                <div className="w-full rounded  px-5 py-10 md:p-10">
                    <div className="wysiwyg" dangerouslySetInnerHTML={{ __html: download_section_text }} />
                    <div>
                        {Boolean(pdf_file?.url) && (
                            <a 
                                href={pdf_file.url} 
                                className="btn hover-bg-main-600 hover-text-white flex-align d-inline-flex gap-8 px-48 mt-20"
                            >
                                Download PDF
                            </a>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default observer(DownloadPdfTab);
